// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3mRRI","subheader":"ReorderModal_subheader__p2G7w","listWrap":"ReorderModal_listWrap__12DR_"};